const changeLengthStringVacancy = () => {
  const textWrapper = document.querySelector('.vacancy-hero__wrapper');

  if (!textWrapper) {
    return;
  }

  const resizeChangeHandler = () => {
    const textContainer = textWrapper.querySelector('.vacancy-hero__text-container');
    const header = textWrapper.querySelector('h2');
    const styleWrapper = getComputedStyle(textWrapper);
    const styleTextContainer = getComputedStyle(textContainer);
    const styleH2 = getComputedStyle(header);
    const widthTextWrapper = parseInt(styleWrapper.width, 10);
    const marginLeftTextContainer = parseInt(styleTextContainer.marginLeft, 10);
    const marginRightTextContainer = parseInt(styleTextContainer.marginRight, 10);
    const widthStyleH2 = parseInt(styleH2.width, 10)
    const fontSizeStyleH2 = parseInt(styleH2.fontSize, 10);

    if (widthStyleH2 > widthTextWrapper - marginLeftTextContainer - marginRightTextContainer) {
      const factor = (widthTextWrapper - marginLeftTextContainer - marginRightTextContainer) / widthStyleH2;
      header.style.setProperty('font-size', `${fontSizeStyleH2 * factor}px`);
    }
  }

  window.addEventListener('resize', resizeChangeHandler);

  resizeChangeHandler();
}

export {changeLengthStringVacancy};
